/**
 * Mixin for adding the custom validation rules
 */
define([
    'jquery',
    'Magento_GiftCardAccount/js/model/payment/gift-card-messages'
], function($, messageList) {
    'use strict';

    return function() {
        var digitOnlyRegExp = new RegExp(/[^\d]/);

        $.validator.addMethod(
            'validate-gift-card-required-entry',
            function(value, element) {
                var isValueEmpty = $.mage.isEmpty(value);
                if (isValueEmpty) {
                    messageList.addErrorMessage({
                        'message': $.mage.__('Some information is missing or incorrect. Please check the red fields for details.')
                    });
                }

                return !isValueEmpty;
            },
            $.mage.__('This field is required')
        );

        $.validator.addMethod(
            'validate-gift-card-code',
            function(value, element) {
                return value.length === 19 && !digitOnlyRegExp.test(value);
            },
            $.mage.__('Please include a valid gift card number (19 digits, numbers only, no spaces)')
        );

        $.validator.addMethod(
            'validate-gift-card-pin',
            function(value, element) {
                return value.length === 4 && !digitOnlyRegExp.test(value);
            },
            $.mage.__('Please include a valid PIN (4 digits, numbers only, no spaces)')
        );
    }
});